import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

export default createStore({
  state: {
    userData: null,
    city: "Москва",
    address: "",
    cityList: [],
    allowRegistration: false,
  },
  getters: {
    getUserData(state) {
      return state.userData;
    },
    getCity(state) {
      return state.city;
    },
    getAddress(state) {
      return state.address;
    },
    getCityList(state) {
      return state.cityList;
    },
    getAllowRegistration(state) {
      return state.allowRegistration;
    },
  },
  mutations: {
    setCity(state, data) {
      state.city = data;
    },
    setUserData(state, data) {
      state.userData = data;
    },
    setAddress(state, data) {
      state.address = data;
    },
    setCityList(state, data) {
      state.cityList = data;
    },
    setAllowRegistration(state, data) {
      state.allowRegistration = data;
    },
  },
  actions: {},
  modules: {},
  plugins: [createPersistedState()],
});
